import React from "react";
import ShopFilters from "./ShopFilters";
import ShopItems from "./ShopItems";
import InfluencersCircles from "../../components/InfluencersCircles";
import Container from "../../components/Container";

const Shop = () => {
  return (
    <>
      <section className="bg-white">
        <Container display={"flex"} width={"w-full"}>
          <div className="w-3/12 xs:hidden lg:block">
            <ShopFilters />
          </div>
          <div className="xs:w-full lg:w-9/12">
            <ShopItems />
          </div>
        </Container>
      </section>
      <section>
        <Container maxWidth={"max-w-full"} width="w-full">
          <InfluencersCircles />
        </Container>
      </section>
    </>
  );
};

export default Shop;
